import { render } from "./ResponsibleModal.vue?vue&type=template&id=2827b550&lang=html"
import script from "./ResponsibleModal.vue?vue&type=script&lang=js"
export * from "./ResponsibleModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dlin\\Desktop\\work\\webportal-lms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__